<template>
    <div id="app">
      <router-view v-if="isLoading" v-wechat-title='this.$route.meta.title' />
      <div class="loading" v-else>{{noticeTxt}}</div>
      <van-tabbar route fixed v-if="isLoading&&showMenu">
        <van-tabbar-item replace to="/" >
          <span>首页</span>
          <template #icon="props">
            <img :src="props.active ? require('./assets/home_active.png') : require('./assets/home.png')" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/canteen" >
          <span>食堂预约</span>
          <template #icon="props">
            <img :src="props.active ? require('./assets/canteen_active.png') : require('./assets/canteen.png')" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/order" >
          <span>订单</span>
          <template #icon="props">
            <img :src="props.active ? require('./assets/orderList_active.png') : require('./assets/orderList.png')" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item replace to="/mine" >
          <span>我的</span>
          <template #icon="props">
            <img :src="props.active ? require('./assets/mine_active.png') : require('./assets/mine.png')" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </template>
  
  <script>
  import md5 from 'js-md5'
  import qs from 'qs'
  import Vue from 'vue';
  import { Tabbar, TabbarItem } from 'vant';
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  
  // 全局注册
  Vue.use(Dialog);
  Vue.use(Toast);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  export default {
    name: 'App',
    data(){
      return {
        showMenu:true,
        isLoading:false,
        noticeTxt:'加载中...'
      }
    },
    created(){
      if(this.$route.path!='/'&&this.$route.path!='/mine'&&this.$route.path!='/order'&&this.$route.path!='/canteen'){
          this.showMenu = false
        }else {
          this.showMenu = true
        }
    },
    watch: {
      $route: function (to, from) {
        if(to.path!='/'&&to.path!='/mine'&&to.path!='/order'&&to.path!='/canteen'){
          this.showMenu = false
        }else {
          this.showMenu = true
        }
        window.scrollTo(0, 0)
      }
    },
    mounted(){
      // this.getToken()
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/TaurusApp/i) == "taurusapp") {
          this.getToken()
      }else{
        this.noticeTxt = '请在浙政钉环境下运行'
        this.isLoading = false
      }
    },
    methods:{
      getToken(){
        let time = new Date().getTime().toString()
        let appid = "sys61492017031814ca08"
        let appkey = "27710c2dcdbbb6106315e32b67e981bc"
        let appkeyAll = md5(appid+time+appkey)
        let param ={
          appid:appid,
          appkey: appkeyAll,
          timespan: time
        }
        this.$post('api/AccessToken', qs.stringify(param),{
          headers:{
              'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          // console.log(res);
          // this.isLoading = true;
          sessionStorage.setItem('token',res.data) 
          // sessionStorage.setItem('userData',JSON.stringify({workerID: '453565'}))
          // return
          dd.ready(()=>{
          dd.getAuthCode({
              corpId: ""
          }).then(result => {
            console.log(result);
            // alert(JSON.stringify(result))
            if (result && (result.auth_code || result.code)) {
              const { auth_code, code } = result
              this.login(auth_code || code)
            } else {
              this.noticeTxt = '加载失败，请退出重试！!'
              this.isLoading = false
            }
              
          }).catch(err => {
            console.log('err',err)
            this.noticeTxt = '加载失败，请退出重试！'
            this.isLoading = false
          })
        });
        })
      },
      login(authCode) {
        let param = {
          auth_code:authCode
        }
       this.$post('api/Dingding/GetUserInfo', qs.stringify(param),{
          headers:{
              'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          if(res.code==1000){
            sessionStorage.setItem('userData',JSON.stringify(res.data))
            this.isLoading = true;
          }else{
            this.noticeTxt = '加载失败，请退出重试！'
            this.isLoading = false
            Dialog.alert({
              title: '提示',
              message: res.msg||res.message,
              confirmButtonText:'关闭页面',
              confirmButtonColor:'#3B87F5'
            }).then(() => {
              // on close
              dd.ready(()=>{
                dd.closePage()
              })
            });
          }
        }).catch(err => {
          this.noticeTxt = '加载失败，请退出重试！'
          this.isLoading = false
        })
      },
    }
  }
  </script>
  
  <style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .loading {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #333;
    font-weight: bold;
  }
  </style>
  


// WEBPACK FOOTER //
// src/App.vue